document.addEventListener("DOMContentLoaded", function () {

  const sections = document.querySelectorAll(
    ".tp-why-choose"
  );

  sections.forEach(function (section) {

    const cards = section.querySelectorAll(
      ".tp-why-card"
    );


    /*
     * Hover state
     */

    cards.forEach(function (card) {

      card.addEventListener("mouseenter", function () {
        card.classList.add("is-hovered");
      });

      card.addEventListener("mouseleave", function () {
        card.classList.remove("is-hovered");
      });

    });


    /*
     * Reveal animation
     */

    if ("IntersectionObserver" in window) {

      const observer = new IntersectionObserver(
        function (entries, observerInstance) {

          entries.forEach(function (entry) {

            if (entry.isIntersecting) {

              entry.target.classList.add("is-visible");

              observerInstance.unobserve(entry.target);

            }

          });

        },
        {
          threshold: 0.15
        }
      );


      cards.forEach(function (card) {
        observer.observe(card);
      });

    } else {

      cards.forEach(function (card) {
        card.classList.add("is-visible");
      });

    }

  });

});